import { Component, Injector, Renderer2 } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { NavigationEnd, Router } from "@angular/router";
import { SubSink } from "subsink";
import { BreadcrumbService } from './layout/service/breadcrumb/breadcrumb.service';
import { CrossStorageService } from './shared/service/cross-storage/cross-storage.service';
import { LoaderService } from './shared/service/loader/loader.service';
import { SessionService } from './shared/service/session/session.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private subs = new SubSink();
  private snackBarRef: MatSnackBarRef<any>;
  show: boolean;
  title: string = "klearusermanagement"

  private session: SessionService;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private renderer: Renderer2,
    private crossStorageService: CrossStorageService,
    private breadcrumbService: BreadcrumbService,
    private loaderService: LoaderService,
    private injector: Injector,
    private sessionService: SessionService //! Do not remove this, this is not unused. This just activates SessionService through DI
  ) {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
    this.subs.sink = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          const loader = this.renderer.selectRootElement("#loader");
          loader.style.display = "none";
        }, 500);
      }
    });
    this.loaderService.show();
    this.breadcrumbService.subscribeToBreadcrumbs();
  }

  ngOnInit() {
    this.crossStorageService.isInfoSet.subscribe({
      next: (isSet: boolean) => {
        if (isSet) {
          this.loaderService.hide();
          this.show = true;
          this.session = this.injector.get(SessionService);
        }
      },
    });
  }

  openSnackBar(message: string, action: string, duration: number) {
    this.snackBarRef = this.snackBar.open(message, action, {
      duration: duration,
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
